import { useNavigate, useSearchParams } from "react-router-dom"
import PageContainer from "../../components/PageContainer";
import { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useDispatch } from "react-redux";
import { emptyCart } from "../../redux/cartSlice";

const ProductPurchased = () => {
    const { t } = useTranslation();
    // Invio email prima del redirect
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const orderId = searchParams.get('orderId');
    const token = localStorage.getItem('ticino-wild-token');
    localStorage.removeItem('ticino-wild-cart');
    dispatch(emptyCart())
    const sendEmails = async () => {
        const url = `${process.env.REACT_APP_SERVER_BASE_URL}/orders/send-purchase-emails/${orderId}`;
        const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };
        const options = { method: 'GET', headers };
        try {
            const url = `${process.env.REACT_APP_SERVER_BASE_URL}/orders/send-purchase-emails/${orderId}`;
            const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };
            const options = { method: 'GET', headers };
            const res = await fetch(url, options);
            const data = await res.json();
            console.log('res: ', data);
        } catch (err) {
            console.log('err: ', err);
        } finally {
            setTimeout(() => {
                navigate("/");
            }, 5000);
        }
    }
    useEffect(() => {
        if(orderId) {
            sendEmails();
        }
    }, [orderId])

    return (
        <PageContainer items="center">
            <div className="min-h-96 flex flex-col gap-4 justify-center items-center">
                <h3 className="text-[#225424]">{t('ProductPurchased.productsBuyed')}</h3>
                {/* <h4>{t('ProductPurchased.willRedirectToHome')}</h4> */}
            </div>
        </PageContainer>
    )
}

export default ProductPurchased